import { formatPaise } from "../../lib/format";

interface ValueFormat {
  value?: string;
  suffix?: string;
}

export function formatReportValue(raw: unknown, format?: ValueFormat): string {
  if (raw === null || raw === undefined) return "—";
  if (format?.value === "paise") return formatPaise(Number(raw));
  if (format?.value === "integer") {
    const n = Number(raw);
    const base = Number.isFinite(n) ? n.toLocaleString("en-IN") : String(raw);
    return `${base}${format.suffix ?? ""}`;
  }
  if (typeof raw === "number") {
    return `${raw.toLocaleString("en-IN")}${format?.suffix ?? ""}`;
  }
  return `${String(raw)}${format?.suffix ?? ""}`;
}
